// extracted by mini-css-extract-plugin
module.exports = {"loader":"_1410bfd27b--loader--gIIa5","skeleton-animation":"_1410bfd27b--skeleton-animation--dY1M9"};